export default {
    getLicenceManagementHeaderFields: state => state.licenceManagementFields
}
